import { APIs } from 'src/models/apis';
import { useQuery } from 'react-query';
import { Events } from 'src/graphql/schema.graphql';
import { UseQueryResult } from 'react-query/types/react/types';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';
import { eventAgendaGqlQuery } from 'src/modules/events/graphql/events-agenda.query';
import { useContext } from 'react';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';

export const fetchEventAgenda = async (apis: APIs, eventId: string) => {
  if (!eventId) {
    return null;
  }

  const directus = await apis.directus();

  return directus
    .query(eventAgendaGqlQuery, {
      filters: { id: { _eq: eventId } },
    })
    .then((d) => d.events?.[0]);
};

export const useEventAgendaQuery = (
  eventId: string,
): UseQueryResult<Pick<Events, 'translations' | 'subEvents'>> => {
  const apis = useAPIs();

  return useQuery(
    [...QueryKey.EventAgenda, eventId],
    () => fetchEventAgenda(apis, eventId),
    {
      refetchInterval: 1000 * 60,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
    },
  );
};

export const useCurrentEventAgendaQuery = () => {
  const { event } = useContext(EventPageContext);

  return useEventAgendaQuery(event.id);
};
